import type { UseMutationOptions } from "@tanstack/react-query"
import { useMutation } from "@tanstack/react-query"
import { AxiosError } from "axios"

import { httpClient } from "~/backend/axios"
import { ErrorLogs } from "~/pages/Admin/Ingestion/ProductImport/hooks/useVerifyProductImportMutation"

export const usePreImportChecksMutation = (
  options?: UseMutationOptions<number, AxiosError<ErrorLogs>, { file: File }>
) =>
  useMutation({
    mutationFn: async ({ file }: { file: File }) => {
      const formData = new FormData()
      formData.set("file", file)

      const response = await httpClient.post(
        "/v1/product/pre-import-check",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      )

      return response.data
    },

    ...options,
  })
